export default "assets/images/bg-2bd76cfd.png";